import React, { useState, useContext, useEffect } from "react";
import { CatTagContext } from "../contexts/CatTagContext";
import { AutoCatContext } from "../contexts/AutoCatContext";
import { MemoContext } from "../contexts/MemoContext";
import { Select, Divider, Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import TagItem from "./TagItem";
import axios from "axios";
import ScanDoc from "./ScanDoc";
import TinyEditor from "../components/TinyEditor";
import Record from "./Record";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 22, color: "white" }} spin />
);

const { Option } = Select;

const EditMemo = ({
  tagData,
  catData,
  mid,
  memo,
  setMemo,
  setPlain,
  memoPlain,
}) => {
  const { autoCat, sugTag, sugCat, load } = useContext(AutoCatContext);
  const { categories, tags, fetchCatTag } = useContext(CatTagContext);
  const { fetchMemo } = useContext(MemoContext);
  const [catItems, setCatItems] = useState([]);
  const [tagItems, setTagItems] = useState([]);
  const [tagValue, setTagValue] = useState([]);
  const [catValue, setCatValue] = useState([]);
  const [userCat, setUserCat] = useState([]);
  const [userTag, setUserTag] = useState([]);
  const [saveLoad, setSaveLoad] = useState(false);

  useEffect(() => {
    setTagValue(sugTag);
  }, [sugTag]);

  useEffect(() => {
    setCatValue(sugCat);
  }, [sugCat]);

  useEffect(() => {
    if (categories.length !== 0) {
      const cat = categories.map((e) => e.category);
      setUserCat(cat);
    }
  }, [categories]);

  useEffect(() => {
    if (tags.length !== 0) {
      const tag = tags.map((e) => <Option key={e.tag}>{e.tag}</Option>);
      setUserTag(tag);
    }
  }, [tags]);

  useEffect(() => {
    if (userCat.length !== 0) {
      setCatItems([...userCat]);
    }
    if (catData) {
      setCatValue(catData);
    }
  }, [userCat, catData]);

  useEffect(() => {
    if (userTag.length !== 0) {
      let memoTagData = [];
      if (tagData) {
        memoTagData = tagData.map((e) => e.tag_name);
      }
      setTagItems([...userTag]);
      setTagValue(memoTagData);
    }
  }, [userTag, tagData]);

  const handleChange = (value) => {
    let check = true;
    value.forEach((e) => {
      if (e.includes("\\")) {
        check = false;
      }
    });
    if (check) {
      setTagValue(value);
    }
  };

  const [newCat, setNewCat] = useState("");

  const onNewCatChange = (event) => {
    setNewCat(event.target.value);
  };

  const addItem = () => {
    let checkDup = true;
    catItems.forEach((e) => {
      if (e === newCat) {
        checkDup = false;
      }
    });
    if (checkDup === true) {
      setCatItems([...catItems, newCat]);
      setNewCat("");
    }
  };

  const saveMemo = () => {
    setSaveLoad(true);
    let formData = {
      editor: memo,
      content: memoPlain,
      // category_id: null,
      // newCat: null,
      // tag_id: [],
      // newTag: [],
    };
    // if (catValue.length > 0) {
    //   categories.forEach((e) => {
    //     if (e.category === catValue.replace(/"/g, "'").replace(/'/g, "\\'")) {
    //       formData.category_id = e.cid;
    //     }
    //   });
    //   if (!formData.category_id) {
    //     if (catValue.length !== 0) {
    //       formData.newCat = catValue.replace(/"/g, "'").replace(/'/g, "\\'");
    //     }
    //   }
    // }

    // tagValue.forEach((a) => {
    //   let check = false;
    //   tags.forEach((b) => {
    //     if (
    //       a.replace(/\\/g, "/").replace(/"/g, "'").replace(/'/g, "\\'") ===
    //       b.tag
    //     ) {
    //       formData.tag_id.push(b.tid);
    //       check = true;
    //     }
    //   });
    //   if (check === false) {
    //     formData.newTag.push(a.replace(/"/g, "'").replace(/'/g, "\\'"));
    //   }
    // });
    axios
      .post(`/memo/${mid}`, {
        editor: formData.editor,
        content: formData.content,
      })
      .then(() => {
        fetchCatTag();
        fetchMemo();
        setTimeout(() => {
          setSaveLoad(false);
        }, 500);
      })
      .catch((e) => console.log(e));
  };

  return (
    <div className="w-full h-full flex flex-col px-4 pr-0 pt-2">
      <div className="tiny h-full">
        {/* <MemoEditor value={memo} setValue={setMemo} /> */}
        <TinyEditor value={memo} setValue={setMemo} setPlain={setPlain} />
      </div>
      <div className="mt-6">
        <Select
          tagRender={TagItem}
          bordered={false}
          size="large"
          mode="tags"
          style={{ width: "100%" }}
          placeholder="Write all your memo tag here.."
          value={tagValue}
          onChange={handleChange}
        >
          {tagItems}
        </Select>
      </div>
      <div className="flex-initial mb-5 flex justify-between items-center">
        <Select
          value={catValue}
          onChange={(v) => setCatValue(v)}
          bordered={false}
          size="large"
          style={{ color: "#4a5568", minWidth: "40%" }}
          placeholder="Choose a category"
          dropdownRender={(menu) => (
            <div>
              {menu}
              <Divider style={{ margin: "4px 0" }} />
              <div className="flex items-center p-2">
                <Input
                  style={{ flex: "auto" }}
                  value={newCat}
                  onChange={onNewCatChange}
                />
                <p
                  onClick={addItem}
                  className="py-1 px-2 m-0 ml-2 bg-blue-400 text-white rounded-sm cursor-pointer"
                >
                  ADD
                </p>
              </div>
            </div>
          )}
        >
          {catItems.map((item) => (
            <Option key={item}>{item}</Option>
          ))}
        </Select>
        <div className="flex">
          <Record memo={memo} setMemo={setMemo} />
          <ScanDoc memo={memo} setMemo={setMemo} />
          <div
            onClick={() => {
              if (!(load[0] && load[1])) {
                autoCat(memoPlain);
              }
            }}
            className="m-0 mr-3 p-3 w-24 text-center font-bold bg-blue-400 text-white rounded-md cursor-pointer hover:bg-blue-500"
          >
            {load[0] && load[1] ? (
              <Spin indicator={antIcon} />
            ) : (
              <span>MEMMIFY</span>
            )}
          </div>
          <div
            onClick={() => {
              if (!saveLoad) {
                saveMemo();
              }
            }}
            className="m-0 mr-2 p-3 text-center w-16 font-bold bg-gray-700 text-white rounded-md cursor-pointer hover:bg-gray-800"
          >
            {saveLoad ? <Spin indicator={antIcon} /> : <span>SAVE</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMemo;
